import React from 'react';
import PropTypes from 'prop-types';
import AddEmailModal from '../AddEmailModal';

const propTypes = {
  onCancelEdit: PropTypes.func.isRequired,
  onFinishEdit: PropTypes.func.isRequired,
  emails: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  emails: [],
};

const AddEmailModalEditor = (props) => {
  const { emails = [], onCancelEdit, onFinishEdit } = props;

  const handleFinishEdit = (newEmails) => {
    onFinishEdit({ emails: newEmails, initialEdit: false });
  };


  return (
    <AddEmailModal
      emails={emails}
      onDismiss={onCancelEdit}
      onSubmit={handleFinishEdit}
      show
    />
  );
};

AddEmailModalEditor.defaultProps = defaultProps;
AddEmailModalEditor.propTypes = propTypes;

export default AddEmailModalEditor;
